import React, { useState } from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
const Navigation = props => {
  const [navbarOpen, setNavbarOpen] = useState(false);

  return (
    <nav className="navbar navbar-light bg-light fixed-top navbar-expand-md">
      <div className="container">
        <button
          type="button"
          className="navbar-toggler collapsed"
          data-toggle="collapse"
          data-target="#navbar"
          aria-expanded="false"
          aria-controls="navbar"
          onClick={() => {
            console.log(navbarOpen);
            setNavbarOpen(open => !open);
          }}
        >
          <>
            <span className="sr-only">Toggle navigation</span>☰
          </>
        </button>{" "}
        <a className="navbar-brand" href="/">
          I'm Alexander <span className="navbar-brand-highlight">Chan</span>
        </a>
        <div
          id="navbar"
          onClick={() => {
            console.log(navbarOpen);
            setNavbarOpen(open => !open);
          }}
          className={`navbar-collapse collapse no-transition ${
            navbarOpen ? "show" : ""
          }`}
        >
          <ul id="hamburger" className="nav navbar-nav ml-auto">
            <li className="active nav-item">
              {" "}
              <HashLink
                to="/#about"
                className="nav-link"
                data-toggle="collapse"
                data-target=".navbar-collapse.in"
              >
                About Me
              </HashLink>
            </li>
            <li className="nav-item">
              {" "}
              <HashLink
                to="/#experience"
                data-toggle="collapse"
                data-target=".navbar-collapse.in"
                className="nav-link"
              >
                Experience
              </HashLink>
            </li>
            <li className="nav-item">
              {" "}
              <HashLink
                to="/#skills"
                data-toggle="collapse"
                data-target=".navbar-collapse.in"
                className="nav-link"
              >
                Skills
              </HashLink>
            </li>
            <li className="nav-item">
              {" "}
              <HashLink
                to="/#education"
                data-toggle="collapse"
                data-target=".navbar-collapse.in"
                className="nav-link"
              >
                Education
              </HashLink>
            </li>
            <li className="nav-item">
              {" "}
              <Link to="/print" className="nav-link">
                Print
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
